import React from "react";
import styled from "styled-components";
import {
  PENDING,
  REV_IN_PROGRESS,
  APPROBED,
  REJECTED,
  BANNED,
} from "../utils/constants";

const TournamentHistory = ({ tournamentHistory, tournaments }) => {
  return (
    <PillRow>
      {tournamentHistory && tournaments
        ? tournaments
            .slice()
            .sort((a, b) => {
              const numA = parseInt(a.name.match(/\d+/)?.[0] || "0");
              const numB = parseInt(b.name.match(/\d+/)?.[0] || "0");
              return numA - numB;
            })
            .map((tournament) => {
              const info = tournamentHistory.find(
                (t) => t.tournamentId === tournament.tournamentId
              );

              let variant = "none";
              let tooltip = "No ha participado";

              if (info) {
                switch (info.status) {
                  case APPROBED:
                    variant = "approved";
                    tooltip = "Participó";
                    break;
                  case REJECTED:
                    variant = "rejected";
                    tooltip = `Inscripción rechazada`;
                    break;
                  case BANNED:
                    variant = "banned";
                    tooltip = `Expulsado del torneo`;
                    break;
                  case REV_IN_PROGRESS:
                    variant = "review";
                    tooltip = "Inscripción en revisión";
                    break;
                  case PENDING:
                    variant = "pending";
                    tooltip = "Pendiente revisar inscripción";
                    break;
                  default:
                    break;
                }
              }

              return (
                <Pill
                  key={tournament.tournamentId}
                  $variant={variant}
                  title={tooltip}
                >
                  {tournament.name.replace("Temporada", "T")}
                </Pill>
              );
            })
        : null}
    </PillRow>
  );
};

const PillRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

const Pill = styled.div`
  padding: 0.4rem 0.85rem;
  border-radius: 20px;
  font-family: var(--v-font-mono);
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  cursor: help;

  background: ${({ $variant }) =>
    $variant === "approved"
      ? "var(--v-mint)"
      : $variant === "rejected"
      ? "var(--v-uv)"
      : $variant === "banned"
      ? "#c9a04e"
      : $variant === "review"
      ? "rgba(255, 159, 67, 0.2)"
      : $variant === "pending"
      ? "rgba(255, 59, 59, 0.15)"
      : "rgba(255, 255, 255, 0.04)"};

  color: ${({ $variant }) =>
    $variant === "approved"
      ? "#000"
      : $variant === "banned"
      ? "#000"
      : $variant === "review"
      ? "#ff9f43"
      : $variant === "pending"
      ? "#ff3b3b"
      : $variant === "rejected"
      ? "#fff"
      : "var(--v-fg-muted)"};
`;

export default TournamentHistory;
